import inviewAnim from "./modules/inview";
import { setHashDetect, smoothScroll, globalNav } from "./modules/libs";
import setHeroBannerSlider from "./modules/setHeroBannerSlider";
import setTabnav from "./modules/setTabNav";
// import { setModal, globalNav } from "./modules/libs";
import setAccordion from "./modules/setAccordion";

setHashDetect();

window.addEventListener('load', () => {
  globalNav();
  smoothScroll();
  setHeroBannerSlider();
  setTabnav();
  inviewAnim();
  setAccordion();
  // setModal();
  // globalNav();
})